import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

function Home() {
  const expRef = useRef(null);

  useEffect(() => {
    const items = document.querySelectorAll('.home-exp-entry');
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.15 }
    );
    items.forEach(item => observer.observe(item));
    return () => observer.disconnect();
  }, []);
  const latestBlog = {
    id: 1,
    title: "Reflections from the 7th Africa's Business Heroes Finale",
    excerpt: "The 7th edition of Africa's Business Heroes (ABH), an initiative by the Jack Ma Foundation, concluded on a truly inspiring note. Attending the finale was more than just participating in an event; it was stepping into a space that represents the future of African entrepreneurship.",
    date: "March 2026",
    image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&h=600&fit=crop"
  };

  return (
    <>
      <section id="home" className="profile-hero">
        <div className="profile-hero-left">
          <div className="profile-hero-content">
            <h1 className="profile-name">Ajang Akoi Arok</h1>
            <p className="profile-tagline">Software Engineer · Frontend Developer · Graphic Designer · Data Analyst</p>
            <p className="profile-location">
              <svg width="16" height="16" fill="#29abe2" viewBox="0 0 24 24" style={{marginRight:'6px',verticalAlign:'middle'}}><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
              Kigali, Rwanda
            </p>
            <p className="profile-bio">A South Sudanese Software Engineer, creative thinker, and emerging leader passionate about technology, design, and social impact. Currently pursuing a Bachelor of Science in Software Engineering at African Leadership University in Kigali, Rwanda. Driven by a mission to use technology as a tool for empowerment and youth development.</p>
            <p className="profile-secondary">Open to collaborations, projects, and opportunities.</p>
            <div className="profile-hero-actions">
              <Link to="/contact" className="profile-btn profile-btn-filled">
                <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
                Message
              </Link>
              <a href="tel:+211922800411" className="profile-btn profile-btn-outline">
                <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
                +211 922 800 411
              </a>
            </div>
            <hr className="profile-divider" />
            <div className="profile-nav-cards">
              <Link to="/about" className="profile-nav-card">About Me</Link>
              <Link to="/services" className="profile-nav-card">Services</Link>
              <Link to="/projects" className="profile-nav-card">Projects</Link>
              <Link to="/blogs" className="profile-nav-card">Blogs</Link>
              <Link to="/contact" className="profile-nav-card">Contact</Link>
            </div>
          </div>
        </div>
        <div className="profile-hero-diagonal"></div>
        <div className="profile-hero-right">
          <img src="/ajang4.jpeg" alt="Ajang Akoi Arok" className="profile-hero-photo" />
        </div>
      </section>

      <section className="insights-section">
        <div className="insights-container">
          <div className="insights-header">
            <div>
              <span className="insights-label">Insights</span>
              <h2 className="insights-heading">Latest thinking &amp; research</h2>
            </div>
            <Link to="/blogs" className="insights-view-all">View all insights →</Link>
          </div>
          <div className="insights-grid">
            <div className="insight-card">
              <img src="https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&h=300&fit=crop" alt="ABH" className="insight-img" />
              <div className="insight-body">
                <span className="insight-tag">Entrepreneurship</span>
                <h3 className="insight-title">Reflections from the 7th Africa's Business Heroes Finale</h3>
                <p className="insight-excerpt">Attending the ABH finale was stepping into a space that represents the future of African entrepreneurship, ambition, creativity, and purpose.</p>
                <Link to="/blog/1" className="insight-read-more">Read more →</Link>
              </div>
            </div>
            <div className="insight-card">
              <img src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=600&h=300&fit=crop" alt="Tech" className="insight-img" />
              <div className="insight-body">
                <span className="insight-tag">Technology</span>
                <h3 className="insight-title">Building Scalable Web Applications with React</h3>
                <p className="insight-excerpt">Modern web development demands performance, scalability, and user-centered design. Here's how React enables all three.</p>
                <Link to="/blogs" className="insight-read-more">Read more →</Link>
              </div>
            </div>
            <div className="insight-card">
              <img src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=600&h=300&fit=crop" alt="Leadership" className="insight-img" />
              <div className="insight-body">
                <span className="insight-tag">Leadership</span>
                <h3 className="insight-title">Why Leadership is About Service, Not Status</h3>
                <p className="insight-excerpt">True leadership means listening, adapting, and uplifting others. My experience at Nile Orphan Care shaped this belief deeply.</p>
                <Link to="/blogs" className="insight-read-more">Read more →</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="home-services-section">
        <div className="insights-container">
          <div className="home-services-header">
            <span className="insights-label">What I Offer</span>
            <h2 className="insights-heading">My Services</h2>
            <p className="home-services-subtitle">Here's how I can help you and your organization grow</p>
            <Link to="/services" className="insights-view-all" style={{display:'block',marginTop:'0.5rem'}}>View all services →</Link>
          </div>
          <div className="home-services-grid">
            {[
              {
                icon: <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" alt="React" width="36" height="36" />,
                title: 'Web Development',
                desc: 'Building responsive, modern web apps with React, HTML, CSS & JavaScript.',
              },
              {
                icon: <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/canva/canva-original.svg" alt="Canva" width="36" height="36" style={{objectFit:'contain'}} />,
                title: 'Graphic Design',
                desc: 'Creating stunning visuals, brand identities and marketing materials with Canva.',
              },
              {
                icon: <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" alt="Python" width="36" height="36" />,
                title: 'Data Analysis',
                desc: 'Transforming raw data into actionable insights using Python and Excel.',
              },
              {
                icon: <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/trello/trello-plain.svg" alt="Trello" width="36" height="36" style={{objectFit:'contain'}} />,
                title: 'Project Management',
                desc: 'Leading teams and delivering projects on time using Agile and Trello.',
              },
              {
                icon: <img src="https://upload.wikimedia.org/wikipedia/commons/c/c9/Linkedin.svg" alt="LinkedIn" width="36" height="36" style={{objectFit:'contain'}} />,
                title: 'Social Media Marketing',
                desc: 'Growing brand presence and engagement across LinkedIn, Instagram & Facebook.',
              },
              {
                icon: <img src="https://upload.wikimedia.org/wikipedia/commons/4/45/Notion_app_logo.png" alt="Notion" width="36" height="36" style={{objectFit:'contain'}} />,
                title: 'Communication',
                desc: 'Crafting clear reports, proposals, and stakeholder communications.',
              },
              {
                icon: <img src="https://upload.wikimedia.org/wikipedia/commons/3/3f/Git_icon.svg" alt="Git" width="36" height="36" style={{objectFit:'contain'}} />,
                title: 'Leadership',
                desc: 'Inspiring teams, driving strategy, and delivering organizational impact.',
              },
              {
                icon: <img src="https://upload.wikimedia.org/wikipedia/commons/d/d5/Slack_icon_2019.svg" alt="Slack" width="36" height="36" style={{objectFit:'contain'}} />,
                title: 'Team Collaboration',
                desc: 'Working effectively with diverse teams using Slack, Notion and shared tools.',
              },
            ].map((s, i) => (
              <Link key={i} to="/services" className="home-service-card" style={{textDecoration:'none'}}>
                <div className="home-service-icon">{s.icon}</div>
                <h3 className="home-service-title">{s.title}</h3>
                <p className="home-service-desc">{s.desc}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="home-exp-section">
        <div className="home-exp-container">
          <div className="home-exp-header">
            <span className="insights-label">My Journey</span>
            <h2 className="insights-heading">Professional Work Experience</h2>
            <p className="home-exp-subtitle">A track record of leadership, communication, and impact</p>
          </div>
          <div className="home-exp-list">
            {[
              {
                role: 'Chief Operating Officer (COO)',
                org: 'Youth Growth Portal',
                location: 'Kigali, Rwanda (Virtual)',
                date: 'Dec 2024 – Present',
                type: 'On-site',
                bullets: [
                  'Oversee daily operations, processes, and systems to keep the organization running smoothly and efficiently',
                  'Execute organizational strategy by turning the vision into clear actions and ensuring teams deliver on goals',
                  'Identify and implement improvements to make operations more effective, organized, and scalable',
                  'Track progress, measure results, and ensure performance targets and milestones are consistently met',
                  'Created and managed content promoting youth opportunities, events, and organizational achievements',
                ],
              },
              {
                role: 'Finance and Program Coordinator',
                org: 'Nile Orphan Care',
                location: 'Juba, South Sudan',
                date: 'Feb 2025 – June 2025',
                type: 'Full-time',
                bullets: [
                  'Coordinated program activities for effective service delivery',
                  'Managed financial records, budgets, and expense tracking',
                  'Prepared reports to support planning and donor communication',
                  'Used digital tools to improve workflow and data management',
                ],
              },
              {
                role: 'Communications Lead',
                org: 'Nile Orphan Care',
                location: 'Juba, South Sudan (Hybrid)',
                date: 'Jan 2021 – Dec 2022',
                type: 'Full-time',
                bullets: [
                  'Developed and managed the Post-Secondary Support System for graduates',
                  'Primary point of contact for stakeholders, partners, and collaborators',
                  'Led all communications, marketing, and social media including newsletters and donor engagement',
                  'Prepared reports, grant proposals, and success stories for donors and partners',
                ],
              },
              {
                role: 'Examination Secretary',
                org: 'Promised Land Primary & Secondary Schools',
                location: 'Juba, South Sudan',
                date: 'Jun 2023 – Dec 2023',
                type: 'On-site',
                bullets: [
                  'Managed preparation, typing, printing, and distribution of exam papers',
                  'Ensured exam materials were secure and integrity was maintained',
                  'Collaborated with staff to streamline exam-related administrative processes',
                ],
              },
              {
                role: 'Teaching Staff',
                org: 'Promised Land Primary School & Inter-Ethnic Academy',
                location: 'Juba, South Sudan',
                date: 'Sept 2022 – May 2023',
                type: 'On-site',
                bullets: [
                  'Taught Mathematics, Science, and English to primary school pupils',
                  'Mentored pupils to improve academic performance',
                  'Developed lesson plans and student-centered teaching strategies',
                  'Taught Mathematics to high school students using interactive methods',
                ],
              },
            ].map((exp, i) => (
              <div key={i} className="home-exp-entry">
                <div className="home-exp-entry-left">
                  <div className="home-exp-entry-dot"></div>
                  <div className="home-exp-entry-date">{exp.date}</div>
                  <div className="home-exp-entry-type">{exp.type}</div>
                </div>
                <div className="home-exp-entry-card">
                  <div className="home-exp-entry-top">
                    <div>
                      <h3 className="home-exp-entry-role">{exp.role}</h3>
                      <p className="home-exp-entry-org">
                        <svg width="14" height="14" fill="#1a6bc4" viewBox="0 0 24 24" style={{marginRight:'5px',verticalAlign:'middle'}}><path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/></svg>
                        {exp.org}
                      </p>
                    </div>
                    <p className="home-exp-entry-location">
                      <svg width="13" height="13" fill="#9ca3af" viewBox="0 0 24 24" style={{marginRight:'4px',verticalAlign:'middle'}}><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
                      {exp.location}
                    </p>
                  </div>
                  <ul className="home-exp-entry-bullets">
                    {exp.bullets.map((b, j) => <li key={j}>{b}</li>)}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="home-edu-section">
        <div className="home-edu-container">
          <div className="home-edu-header">
            <span className="insights-label">My Education</span>
            <h2 className="insights-heading">Educational Background</h2>
            <p className="home-exp-subtitle">Building a strong foundation in technology and leadership</p>
          </div>
          <div className="home-edu-card">
            <div className="home-edu-icon-wrap">
              <svg width="48" height="48" fill="#1a6bc4" viewBox="0 0 24 24"><path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zM5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z"/></svg>
            </div>
            <div className="home-edu-body">
              <div className="home-edu-top">
                <div>
                  <h3 className="home-edu-uni">African Leadership University</h3>
                  <p className="home-edu-degree">Bachelor of Science in Software Engineering</p>
                </div>
                <div className="home-edu-meta">
                  <span>
                    <svg width="13" height="13" fill="#9ca3af" viewBox="0 0 24 24" style={{marginRight:'4px',verticalAlign:'middle'}}><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
                    Kigali, Rwanda
                  </span>
                  <span>
                    <svg width="13" height="13" fill="#9ca3af" viewBox="0 0 24 24" style={{marginRight:'4px',verticalAlign:'middle'}}><path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z"/></svg>
                    Sept 2025 – Present
                  </span>
                </div>
              </div>
              <div className="home-edu-courses">
                <p className="home-edu-courses-label">Relevant Coursework</p>
                <div className="home-edu-tags">
                  {['Software Engineering Principles','Data Science','Machine Learning','Product Management','Frontend Development','Data Analysis','Mobile Application Development','UX/UI Design','Graphic Design','Responsible Leadership'].map((c, i) => (
                    <span key={i} className="home-edu-tag">{c}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="home-skills-section">
        <div className="home-skills-container">
          <div className="home-skills-header">
            <span className="insights-label">What I Bring</span>
            <h2 className="insights-heading">My Skills</h2>
            <p className="home-exp-subtitle">A diverse set of skills built through education and hands-on experience</p>
          </div>
          <div className="home-skills-grid">
            {[
              { img: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/canva/canva-original.svg',                                          label: 'Graphic Design (Canva)' },
              { img: 'https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg',                                               label: 'Microsoft Suites' },
              { img: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg',                                          label: 'Web Development' },
              { img: 'https://upload.wikimedia.org/wikipedia/commons/c/c9/Linkedin.svg',                                                     label: 'Social Media Management' },
              { img: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg',                                        label: 'Data Analysis & Visualization' },
              { img: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/trello/trello-plain.svg',                                           label: 'Task Prioritization' },
              { img: 'https://upload.wikimedia.org/wikipedia/commons/4/45/Notion_app_logo.png',                                              label: 'Report Writing' },
              { img: 'https://upload.wikimedia.org/wikipedia/commons/f/fd/Microsoft_Office_Word_%282019%E2%80%93present%29.svg',             label: 'Documentation' },
              { img: 'https://upload.wikimedia.org/wikipedia/commons/f/f9/Salesforce.com_logo.svg',                                         label: 'Proposal Writing' },
              { img: 'https://upload.wikimedia.org/wikipedia/commons/d/d5/Slack_icon_2019.svg',                                             label: 'Communication for Impact' },
              { img: 'https://upload.wikimedia.org/wikipedia/commons/3/3f/Git_icon.svg',                                                    label: 'Multitasking Efficiency' },
              { img: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg',                                            label: 'Search Engine Optimization' },
            ].map((s, i) => (
              <div key={i} className="home-skill-card">
                <img src={s.img} alt={s.label} className="home-skill-img" />
                <p className="home-skill-label">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
